import * as React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Divider,
  CardMedia,
  IconButton,
  Box,
} from '@mui/material'
import ModalImage from '../ModalImage'
import { CardFooter } from '../Footer'
import { useState } from 'react'
import { truncateText } from '~/utils/strings'
import { Download } from '@mui/icons-material'
import { useHookstate } from '@hookstate/core'
import { useLang } from '~/hooks/useLang'
import Zoom from 'react-medium-image-zoom'
import { downloadFile, getTypeFile } from '~/utils/media'
import { ExpandTextButton } from '~/components/ExpandTextButton'
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo'
import DialogCardVideo from '../ModalVideo'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import ModalMediaCarousel from '../ModalMediaCarousel'

export function Media({ commentData, allComments }) {
  const { translate } = useLang()
  const [openImage, setOpenImage] = useState(false)
  const typeDocument = useHookstate<string | null>(null)
  const openModalMedia = useHookstate(false)
  const currentMediaIndex = useHookstate(0)

  const handleOpen = () => setOpenImage(true)
  const handleClose = () => setOpenImage(false)

  const { mediaPath, comment, fileType, fileName } = commentData.get()

  React.useEffect(() => {
    getTypeFile({ typeName: fileType, typeDocument: typeDocument })
  }, [])

  const handleOpenMedia = () => {
    const mediaItems = allComments
      .get()
      .filter((c) => c.mediaPath && ['png', 'jpeg', 'jpg', 'mp4'].includes(c.fileType))
      .map((c) => ({ mediaPath: c.mediaPath, fileType: c.fileType, id: c.id }))

    const index = mediaItems.findIndex((item) => item.id === commentData.get().id)
    currentMediaIndex.set(index >= 0 ? index : 0)
    openModalMedia.set(true)
  }

  const mediaItems = allComments
    .get()
    .filter((c) => c.mediaPath && ['png', 'jpeg', 'jpg', 'mp4'].includes(c.fileType))
    .map((c) => ({ mediaPath: c.mediaPath, fileType: c.fileType, id: c.id }))

  return (
    <>
      <Card
        variant="elevation"
        color="background.paper"
        elevation={2}
        sx={{ width: '100%' }}
      >
        <CardContent sx={{ padding: 1 }}>
          <Typography
            style={{ wordWrap: 'break-word', marginBottom: '0' }}
            fontWeight="400"
            paragraph={true}
          >
            {fileType != null ? (
              fileType === 'png' ||
              fileType === 'jpeg' ||
              fileType === 'jpg' ? (
                <Box
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  width={'100%'}
                  onClick={handleOpenMedia}
                  sx={{ cursor: 'pointer' }}
                >
                  <CardMedia
                    component="img"
                    image={mediaPath}
                    alt={comment}
                    sx={{
                      width: '100px',
                    }}
                  />
                </Box>
              ) : fileType === 'mp4' ? (
                <Box
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  width={'100%'}
                  position={'relative'}
                >
                  <video
                    src={mediaPath}
                    width="100"
                    onClick={handleOpenMedia}
                    style={{ cursor: 'pointer' }}
                    muted
                  />
                  <Box
                    position={'absolute'}
                    top={'50%'}
                    left={'50%'}
                    onClick={handleOpenMedia}
                    sx={{
                      transform: 'translate(-50%, -50%)',
                      cursor: 'pointer',
                      transition: 'opacity 0.3s ease',
                      '&:hover': { opacity: 0.7 },
                    }}
                  >
                    <PlayArrowIcon sx={{ fontSize: 48, color: 'white' }} />
                  </Box>
                </Box>
              ) : (
                <Box
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'space-between'}
                >
                  <Typography>
                    {truncateText(
                      `${fileName ? fileName : translate('File')}`,
                      30
                    )}
                  </Typography>
                  <IconButton
                    title={translate('Download file')}
                    onClick={() =>
                      downloadFile({
                        mediaPath: mediaPath,
                        fileType: fileType,
                        typeDocument: typeDocument,
                        isMount: true,
                        fileName: fileName,
                      })
                    }
                  >
                    <Download />
                  </IconButton>
                </Box>
              )
            ) : (
              <Typography
                style={{
                  wordWrap: 'break-word',
                  marginBottom: '0',
                  whiteSpace: 'pre-line',
                }}
                fontWeight="400"
                paragraph={true}
              >
                Upload de media
              </Typography>
            )}
          </Typography>
        </CardContent>

        <Divider />
        <CardFooter commentData={commentData} />
      </Card>
      {(fileType === 'mp4' || fileType === 'png' || fileType === 'jpeg' || fileType === 'jpg') && (
        <ModalMediaCarousel
          open={openModalMedia}
          mediaItems={mediaItems}
          currentIndex={currentMediaIndex}
        />
      )}
    </>
  )
}
